import Select from '@jetbrains/ring-ui/components/select/select'
import classNames from 'classnames'
import {useCallback} from 'react'

import type {Props, UserSelectSelectedItem} from './UserSelect.types'
import {SELECT_ITEM_ALL_VALUE} from './UserSelect.utils'

import styles from './UserSelect.css'

function UserSelect({
  className,
  popupClassName,
  buttonClassName,
  label = 'All users',
  onChange,
  ...otherProps
}: Props) {
  const onChangeSelect = useCallback(
    (item: UserSelectSelectedItem) => onChange(item?.value !== SELECT_ITEM_ALL_VALUE ? item : null),
    [onChange],
  )
  return (
    <Select
      className={classNames(styles.select, className)}
      buttonClassName={classNames(styles.selectButton, buttonClassName)}
      popupClassName={popupClassName}
      type={Select.Type.BUTTON}
      size={Select.Size.AUTO}
      ringPopupTarget="body"
      label={label}
      onChange={onChangeSelect}
      filter
      clear
      {...otherProps}
    />
  )
}

export default UserSelect
